const translation = {
  HOME: 'Home',
  ABOUT: 'About',
  EXPERIENCE: 'Experience',
  SERVICES: 'Services',
  SERVICES: 'Services',
  PORTFOLIO: 'Portfolio',
  TESTIMONIALS: 'Testimonial',
  CONTACT: 'CONTACT',
  COPY_RIGHT: 'Made by Fakhreddine Messaoudi. All right reserved',
};

export default translation;
